/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/dropdown/bs-dropdown-container.component';
import * as import2 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
const styles_BsDropdownContainerComponent:any[] = ([] as any[]);
export const RenderType_BsDropdownContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_BsDropdownContainerComponent,
  data: {}
}
);
export function View_BsDropdownContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',([] as any[]),[
      [
        2,
        'dropup',
        (null as any)
      ]
      ,
      [
        2,
        'dropdown',
        (null as any)
      ]
      ,
      [
        2,
        'show',
        (null as any)
      ]
      ,
      [
        2,
        'open',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.BsDropdownContainerComponent = v.component;
    const currVal_0:any = (co.direction === 'up');
    const currVal_1:any = (co.direction === 'down');
    const currVal_2:any = co.isOpen;
    const currVal_3:any = co.isOpen;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  });
}
function View_BsDropdownContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'bs-dropdown-container',[[
        'style',
        'display:block;position: absolute;'
      ]
    ],(null as any),(null as any),(null as any),View_BsDropdownContainerComponent_0,RenderType_BsDropdownContainerComponent)),
    import0.ɵdid(90112,(null as any),0,import1.BsDropdownContainerComponent,[
      import2.BsDropdownState,
      import0.ChangeDetectorRef,
      import0.Renderer,
      import0.ElementRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const BsDropdownContainerComponentNgFactory:import0.ComponentFactory<import1.BsDropdownContainerComponent> = import0.ɵccf('bs-dropdown-container',import1.BsDropdownContainerComponent,View_BsDropdownContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9kcm9wZG93bi9icy1kcm9wZG93bi1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9kcm9wZG93bi9icy1kcm9wZG93bi1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvZHJvcGRvd24vYnMtZHJvcGRvd24tY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLkJzRHJvcGRvd25Db250YWluZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9kcm9wZG93bi9icy1kcm9wZG93bi1jb250YWluZXIuY29tcG9uZW50LmQudHMuQnNEcm9wZG93bkNvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgW2NsYXNzLmRyb3B1cF09XCJkaXJlY3Rpb24gPT09ICd1cCdcIlxuICAgICAgICAgW2NsYXNzLmRyb3Bkb3duXT1cImRpcmVjdGlvbiA9PT0gJ2Rvd24nXCJcbiAgICAgICAgIFtjbGFzcy5zaG93XT1cImlzT3BlblwiXG4gICAgICAgICBbY2xhc3Mub3Blbl09XCJpc09wZW5cIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICIsIjxicy1kcm9wZG93bi1jb250YWluZXI+PC9icy1kcm9wZG93bi1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUNJO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUcyQjtJQUErQjs7OztJQUhyRDtJQUNBO0lBQ0E7SUFDQTtJQUhMLFNBQUssVUFDQSxVQUNBLFVBQ0EsU0FITDs7Ozs7TUNESjtRQUFBO1FBQUE7TUFBQTtJQUFBO2dCQUFBOzs7OztJQUFBO0tBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory.ts